import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/ProductImage/ProductImage.js";
const variants = import.meta.webpackContext("/components/ProductImage", { recursive: true, regExp: /\.\/__variants__\/plp\-grid\-expansion\-four\/v2\/ProductImage\.js/ });
export default pointCut({ joinPoint, variants });